module.exports = __webpack_public_path__ + "static/media/logoLearning.1a49a51b.svg";